<script>
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import GoogleSignInButton from "vue-google-signin-button-directive";
import GoogleSignInButton from "vue-google-identity-login-btn";
/**
 * Login component
 */
export default {
    page: {
        title: "Login",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    directives: {
        GoogleSignInButton,
    },
    data() {
        return {
            submitted: false,
            authError: null,
            tryingToLogIn: false,
            isAuthError: false,
            buttonName: "Login",
            clientId: window.GLOBAL_GOOGLE_CLIENT_ID,
            emailConfirm: false,
            emailToConfirm: "",
            hris: {
                userName: "",
                password: "",
            },
            giams: {
                userName: "",
                password: "",
            },
            loginHRIS: false,
            viewClip: false,
            hrisStyle: '',
            isOriginalApp: window.ORIGINAL_APP
        };
    },
    mounted(){
        if(this.isOriginalApp){
            let client = this.$refs.viaHRIS.getBoundingClientRect();
            this.hrisStyle = `clip-path: circle(0% at ${client.x}px ${client.y}px);`
        }
    },
    validations: {
        giams: {
            userName: {
                required,
            },
            password: {
                required,
            },
        },

        hris: {
            userName: { required },
            password: { required },
        },
    },
    computed: {
        notification() {
            return this.$store ? this.$store.state.notification : null;
        },
        returnBasedTheme(){
            return localStorage.getItem('theme') && localStorage.getItem('theme') === 'light' ? 'filled_white' : 'filled_black'
        }
    },
    methods: {
        // Try to log the user in with the username
        // and password they provided.
        tryToLogIn() {
            this.submitted = true;
            this.emailConfirm = false;
            this.isAuthError = false;
            // stop here if form is invalid
            this.$v.giams.$touch();
            if (this.$v.giams.$invalid) {
                return;
            } else {
                this.buttonName = "Logging In";
                this.$store
                    .dispatch("account/Login", this.giams)
                    .then((res) => {
                        if (res.data.error) {
                            if (res.data.errorMessage.includes("email account")) {
                                this.emailConfirm = true;
                                this.authError = `${res.data.errorMessage}`;
                                this.emailToConfirm = res.data.messageData;
                            } else {
                                this.isAuthError = true;
                                this.authError = res.data.errorMessage;
                            }
                            this.buttonName = "Login";
                        } else {
                            // return console.log(res.data);
                            res.data.department.deliveryUnit['isExternal'] = res.data.department.deliveryUnit.office.isExternal;
                            res.data.department.deliveryUnit['campusId'] = res.data.department.deliveryUnit.office.campusId;
                            localStorage.setItem("user", JSON.stringify(res.data));
                            localStorage.setItem("accessToken", res.data.accessToken);
                            localStorage.setItem("userAccess", res.data.userAccessList);
                            localStorage.setItem("campusAccess", res.data.campusAccess);
                            localStorage.setItem("roles", res.data.roles);
                            localStorage.setItem('duAccess', JSON.stringify(res.data.myDeliveryUnits));
                            localStorage.setItem('refreshToken', res.data.refreshToken);
                            if (res.data.passwordChanged) {
                                return this.$router.go("/");
                            } else {
                                return this.$router.go("/reset-password");
                            }
                        }
                    })
                    .catch((err) => {
                        this.isAuthError = true;
                        this.authError = "Something went wrong";
                        this.buttonName = "Login";
                    });
            }
        },
        onGoogleAuthSuccess(data) {
            this.$store
                .dispatch("auth/googleLogin", { googleToken: data })
                .then((response) => {
                    if (response.data.error) {
                        return this.showToast(response.data.errorMessage, "error");
                    }
                    response.data.department.deliveryUnit['isExternal'] = response.data.department.deliveryUnit.office.isExternal;
                    response.data.department.deliveryUnit['campusId'] = response.data.department.deliveryUnit.office.campusId;
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("accessToken", response.data.accessToken);
                    localStorage.setItem("userAccess", response.data.userAccessList);
                    localStorage.setItem("campusAccess", response.data.campusAccess);
                    localStorage.setItem("roles", response.data.roles);
                    localStorage.setItem('duAccess', JSON.stringify(response.data.myDeliveryUnits));
                    localStorage.setItem('refreshToken', response.data.refreshToken);
                    if (response.data.passwordChanged) {
                        return this.$router.go("/");
                    } else {
                        return this.$router.go("/reset-password");
                    }
                })
                .catch((error) => {
                    this.showToast("Login failure. Something went wrong. Please try again later", "error");
                    return;
                });
        },
        resendConfirmation() {
            const url = `${window.location.origin}/confirmation`;
            this.pageLoader(true);
            this.$store
                .dispatch("auth/sendEmailConfirmation", {
                    email: this.emailToConfirm,
                    url: url,
                })
                .then(() => {
                    this.pageLoader(false);
                    this.showToast("Successfully sent to Email", "success");
                })
                .catch((error) => {
                    this.pageLoader(false);
                    this.showToast(
                        "Cannot send confirmation to user. Please ask your administrator",
                        "error"
                    );
                });
        },
        OnGoogleAuthFail(data) {
            console.log(data);
        },
        HRISLogin() {
            this.submitted = true;
            this.emailConfirm = false;
            this.isAuthError = false;
            // stop here if form is invalid
            this.$v.hris.$touch();
            if (this.$v.hris.$invalid) {
                return;
            } else {
                this.buttonName = "Logging In";
                this.$store
                    .dispatch("auth/loginWithHRIS", this.hris)
                    .then((res) => {
                        if (res.data.error) {
                            if (res.data.errorMessage.includes("email account")) {
                                this.emailConfirm = true;
                                this.authError = `${res.data.errorMessage}`;
                                this.emailToConfirm = res.data.messageData;
                            } else {
                                this.isAuthError = true;
                                this.authError = res.data.errorMessage;
                            }
                            this.buttonName = "Login";
                        } else {
                            res.data.department.deliveryUnit['isExternal'] = res.data.department.deliveryUnit.office.isExternal;
                            res.data.department.deliveryUnit['campusId'] = res.data.department.deliveryUnit.office.campusId;
                            localStorage.setItem("user", JSON.stringify(res.data));
                            localStorage.setItem("accessToken", res.data.accessToken);
                            localStorage.setItem("userAccess", res.data.userAccessList);
                            localStorage.setItem("campusAccess", res.data.campusAccess);
                            localStorage.setItem("duAccess", JSON.stringify(res.data.myDeliveryUnits));
                            localStorage.setItem('refreshToken', res.data.refreshToken);
                            localStorage.setItem("roles", res.data.roles);
                            if (res.data.passwordChanged) {
                                return this.$router.go("/");
                            } else {
                                return this.$router.go("/reset-password");
                            }
                        }
                    })
                    .catch((err) => {
                        this.isAuthError = true;
                        this.authError = "Something went wrong";
                        this.buttonName = "Login";
                    });
            }
        },
        loginViaHRIS() {
            let client = this.$refs.viaHRIS.getBoundingClientRect();
            if (!this.loginHRIS) {
                this.hrisStyle = `clip-path: circle(100% at ${client.x}px ${client.y}px);`
                this.loginHRIS = true;
                this.viewClip = true;
            } else {
                this.loginHRIS = false;
                this.hrisStyle = `clip-path: circle(0% at ${client.x}px ${client.y}px);`
                this.viewClip = false;
                this.isAuthError = false;
            }
        },
    },
};
</script>

<template>
    <div class="login-view">
        <div class="clip-path-circle" :style="hrisStyle" v-if="isOriginalApp">
            <div>
                <div>
                    <div class="application-info">
                        <b>HR Integrated System</b>
                        <br />for University of Science and Technology of
                        Southern Philippines
                    </div>

                    <div class="login-block" style="margin-top: 50px">
                        <div class="block block-transparent">
                            <div class="head">
                                <div class="user">
                                    <div class="d-flex justify-content-center">
                                        <img
                                            src="@/assets/images/logo/ustp.png"
                                            style="height: 150px"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 d-flex justify-content-center">
                                <form
                                    @submit.prevent="HRISLogin"
                                    class="w-250px"
                                >
                                      <span class="text-danger" v-if="isAuthError"><i>{{authError}}</i></span>
                                    <div class="input-group mb-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"
                                                ><i
                                                    class="mdi mdi-account-lock"
                                                ></i
                                            ></span>
                                        </div>
                                        <input
                                            type="text"
                                            class="
                                                form-control form-control-sm
                                                bg-negative-2
                                            "
                                            placeholder="Username"
                                            v-model="hris.userName"
                                            autocomplete="off"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.hris.userName.$error,
                                            }"
                                            :disabled="
                                                buttonName === 'Logging In'
                                            "
                                        />
                                    </div>
                                    <div class="input-group mb-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"
                                                ><i
                                                    class="mdi mdi-key-variant"
                                                ></i
                                            ></span>
                                        </div>
                                        <input
                                            type="password"
                                            class="
                                                form-control form-control-sm
                                                bg-negative-2
                                            "
                                            placeholder="Password"
                                            v-model="hris.password"
                                            autocomplete="off"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.hris.password.$error,
                                            }"
                                            :disabled="
                                                buttonName === 'Logging In'
                                            "
                                        />
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-12">
                                            <button
                                                type="submit"
                                                class="
                                                    btn
                                                    btn-default
                                                    btn-block
                                                    btn-clean
                                                "
                                                :disabled="
                                                    buttonName === 'Logging In'
                                                "
                                            >
                                              <div class="d-flex justify-content-center align-items-center">
                                                <b-spinner
                                                    class="small-size"
                                                    variant="dark"
                                                    role="status"
                                                    v-show="
                                                        buttonName ===
                                                        'Logging In'
                                                    "
                                                ></b-spinner>
                                                {{ buttonName }}
                                              </div>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="position-fixed"
            style="top: 10px; right: 10px;z-index:102"
            v-if="viewClip && isOriginalApp"
        >
            <a
                href="javascript:void(0);"
                class="text-white"
                @click="loginViaHRIS"
                ><i class="bx bx-x" style="font-size: 4rem;"></i
            ></a>
        </div>
        <div
            id="g_id_onload"
            :data-client_id="clientId"
            data-login_uri="https://your.domain/your_login_endpoint"
            data-your_own_param_1_to_login="any_value"
            data-your_own_param_2_to_login="any_value"
        ></div>

        <div
            class="d-flex justify-content-center flex-column align-items-center opac-transition" :class="{ active: loginHRIS }"
        >
            <div class="login-width">
                <div class="card ">
                    <div class="bg-soft bg-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary">Welcome Back !</h5>
                                    <p>Sign in to continue to GIAMS.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img
                                    src="@/assets/images/profile-img.png"
                                    alt
                                    class="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div>
                            <router-link tag="a" to="/">
                                <div class="avatar-md profile-user-wid mb-4">
                                    <span
                                        class="
                                            avatar-title
                                            rounded-circle
                                            bg-light
                                        "
                                    >
                                        <img
                                            src="@/assets/images/logo/g-colored.png"
                                            alt
                                            height="60"
                                        />
                                    </span>
                                </div>
                            </router-link>
                        </div>
                        <b-alert
                            v-model="isAuthError"
                            variant="danger"
                            class="mt-3"
                            dismissible
                            >{{ authError }}</b-alert
                        >
                        <b-alert
                            v-model="emailConfirm"
                            variant="warning"
                            class="mt-3"
                            dismissible
                            >{{ authError }}
                            <br />
                            {{ emailToConfirm
                            }}<a
                                href="javascript:void(0);"
                                @click="resendConfirmation()"
                            >
                                [Resend Confirmation]</a
                            >
                        </b-alert>

                        <div
                            v-if="notification.message"
                            :class="'alert ' + notification.type"
                        >
                            {{ notification.message }}
                        </div>
                        <b-form class="px-2" @submit.prevent="tryToLogIn">
                            <b-form-group
                                class="mb-3"
                                id="input-group-1"
                                label="Username"
                                label-for="input-1"
                            >
                                <b-form-input
                                    id="input-1"
                                    v-model="giams.userName"
                                    type="text"
                                    placeholder="Enter username"
                                    autocomplete="off"
                                    :class="{'is-invalid': submitted && $v.giams.userName.$error}"
                                    :disabled="buttonName === 'Logging In'"
                                ></b-form-input>
                                <div
                                    v-if="submitted && $v.giams.userName.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.giams.userName.required"
                                        >Username is required.</span
                                    >
                                </div>
                            </b-form-group>

                            <b-form-group
                                class="mb-3"
                                id="input-group-2"
                                label="Password"
                                label-for="input-2"
                            >
                                <b-form-input
                                    id="input-2"
                                    v-model="giams.password"
                                    type="password"
                                    placeholder="Enter password"
                                    :class="{
                                        'is-invalid':
                                            submitted &&
                                            $v.giams.password.$error,
                                    }"
                                    :disabled="buttonName === 'Logging In'"
                                ></b-form-input>
                                <div
                                    v-if="
                                        submitted && !$v.giams.password.required
                                    "
                                    class="invalid-feedback"
                                >
                                    Password is required.
                                </div>
                            </b-form-group>
                            <div class="mt-3 d-grid">
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                        btn-block
                                        me-4
                                    "
                                    :disabled="buttonName === 'Logging In'"
                                >
                                    <b-spinner
                                        class="m-2 small-size"
                                        variant="dark"
                                        role="status"
                                        v-show="buttonName === 'Logging In'"
                                    ></b-spinner>
                                    {{ buttonName }}
                                </b-button>
                                <div class="my-3 text-center">
                                    <span class="">OR</span>
                                </div>
                                <div
                                    class="
                                        d-flex
                                        justify-content-center
                                        align-items-center
                                        flex-mobile
                                    "
                                >
                                    <div
                                        class="
                                            position-relative
                                            me-2
                                            cursor-pointer
                                            w-200px
                                        "
                                        @click="loginViaHRIS"
                                        ref="viaHRIS"
                                        v-if="isOriginalApp"
                                    >
                                        <div
                                            class="
                                                bg-hris
                                                d-flex
                                                align-items-center
                                                justify-content-center
                                            "
                                            style="border-radius: 5px"
                                        >
                                            <div
                                                class="
                                                    d-flex
                                                    justify-content-center
                                                    bg-white
                                                    align-items-center
                                                    me-2
                                                    hris-logo
                                                "
                                            >
                                                <img
                                                    src="@/assets/images/logo/ustp.png"
                                                    alt
                                                    height="40"
                                                />
                                            </div>
                                            <span
                                                class="
                                                    text-white
                                                    hris-logo-text
                                                "
                                                >Login with HRIS</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        id="google-login-btn"
                                        v-google-identity-login-btn="{
                                            clientId,
                                            locale: 'en',
                                            width: isOriginalApp ? '200px' : '100%',
                                            shape: 'pill',
                                            theme: returnBasedTheme,
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <div class="mt-3 text-center">
                                <router-link
                                    tag="a"
                                    to="/forgot-password"
                                    class="text-muted"
                                >
                                    <i class="mdi mdi-lock me-1"></i> Forgot
                                    your password?
                                </router-link>
                            </div>
                        </b-form>
                    </div>
                    <!-- end card-body -->
                </div>
                <div class="mt-3 text-center">
                    <p>Don't have an account ? Contact Admin</p>
                    <p>© {{ new Date().getFullYear() }} USTP | GIAMS</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.small-size {
    width: 15px;
    height: 15px;
}
.row {
    width: 100%;
}
.application-info {
    text-align: center;
    margin-top: 30px;
    font-size: 16px;
    color: #fff;
}
.login-block {
    width: 300px;
    margin: 100px auto 0px;
}
.btn-clean {
    border-color: #fff;
    background: transparent;
    color: #fff;
    line-height: 16px;
    padding: 6px 12px 5px;
    font-size: 12px;
    font-weight: bold;
}
.form-custom {
    background: rgba(0, 0, 0, 0.2);
    border-color: transparent;
    color: #fff;
    padding: 6px 12px;
    font-size: 12px;
    height: 30px;
    line-height: 1.42857143;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}
.form-control::placeholder {
    color: #fff !important;
}
.input-group {
    line-height: 28px;
}
.input-group-text {
    padding: 3px 10px;
}
.bg-negative-2{
    background-color: var(--bs-emphasis-color);
}
</style>
